export enum EModes {
  Parents,
  Organization,
  Students,
}
